import { api } from 'services/api';

export class TechnicianService {
  async listAdditionalServices() {
    return api.get('/budgets/additional-services');
  }
}

export const technicianService = new TechnicianService();
